import { getAppServices } from "@10x/coreapp";
import { switchEjariUserMode } from "@eres/ejari-core/contexts/EjariContext";
import { navigateWithInParent } from "@my-dld/utils/StoreUtils";
import { ProjectProperty } from "@eres/ejari-api/Entity/LeasedProperties";
import { resetData } from "./Utils";

export function showAddPropertySearch() {
	resetData();
	getAppServices().navigationService.navigate( "/mydld/addproperty/search" );
}

export function showProperties() {
	getAppServices().navigationService.navigate( "/mydld/addproperty/properties" );
}

export function showEjariDetails( property: ProjectProperty ) {
	switchEjariUserMode( "owner" );
	navigateWithInParent( "mydld",
		`leased/property/${ property.PropertyTypeId }/${ property.PropertyId }/${ property.IsFreeHold }/${ true }/ejarisvc` );
}
